import { ComponentSingleStyleConfig } from '@chakra-ui/theme'; // Single component style config type

// Form content label style
const FormLabel: ComponentSingleStyleConfig = {
  // Base styles
  baseStyle: {
    fontSize: '18px',
    fontWeight: 'semibold',
    lineHeight: '24px',
  },
};

export default FormLabel;
